import * as _ from "lodash"
import { TravellerQuote } from "@requests"

export interface IHasBaseTravellerQuoteObject {
    getBaseTravellerQuoteObject(): TravellerQuote | undefined
    setBaseTravellerQuoteObject(baseQuoteObject: TravellerQuote): void
}

function hasBaseTravellerQuoteObject<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasBaseTravellerQuoteObject {
        private baseTravellerQuoteObject: TravellerQuote | undefined

        constructor(...args: any[]) {
            super(...args);
        }

        public getBaseTravellerQuoteObject(): TravellerQuote | undefined {
            return this.baseTravellerQuoteObject
        }
        public setBaseTravellerQuoteObject(baseTravellerQuoteObject: TravellerQuote): void {
            this.baseTravellerQuoteObject = _.cloneDeep(baseTravellerQuoteObject)
        }
    };
}

export default hasBaseTravellerQuoteObject